import { createFileRoute } from '@tanstack/react-router';
import { fetchActionDetail } from '@/api/capa';
import { queryClient } from '@/lib/utils/queryClient';
import { ActionDetailContent } from '../../../../-components/ActionDetailContent';

export const Route = createFileRoute(
  '/(client)/capa/(pages)/(detail)/actions/$id/',
)({
  loader: ({ params }) =>
    queryClient.ensureQueryData({
      queryKey: ['capa-action-detail', params.id],
      queryFn: () => fetchActionDetail(params.id),
    }),
  component: ActionDetailPage,
});

function ActionDetailPage() {
  const { id } = Route.useParams();
  // Scrolling is owned by the (detail) layout — no wrapper here.
  return <ActionDetailContent id={id} />;
}
